import * as React from "react";
import { useEffect, useState } from "react";
import { PopupBody, PopupFooter, PopupHeader, Popup } from "./Popup";
import { config, IIdentifyCondition } from "../Map/config";
import { Gallery, GalleryImage } from "../Gallery/Gallery";
import { getRelatedImagesUrls } from "../Providers/imageProvider";
import { useNomaContext } from "../Contexts/MapContext";
import { CloseButton } from "../Elements/CloseButton";
import { PopupButton } from "../Elements/PopupButton";
import { Condition } from "../Map/enums";
import { useCustomViewContext } from "../Contexts/CustomViewContext";
import { PopupRow } from "./PopupRow";

export const Identify = (): JSX.Element => {
    const {
        isMobile,
        identifiedFeature,
        setIdentifiedFeature,
        setPreviewFeature,
        setLocateFeature,
        setZoomToSourceFeatures
    } = useNomaContext();

    const { setHidden } = useCustomViewContext();

    const onZoomTo = () => {
        setHidden(true);
        setLocateFeature(identifiedFeature);
        setIdentifiedFeature(null);
    };

    const x = document.body.clientWidth / 2 - 225; // 225 is identify popup maxWidth/2

    return (
        <Popup id={"identify-popup"} isMobile={isMobile} hasBackdrop={false} defaultPosition={{ x, y: 0 }}>
            <PopupHeader isMobile={isMobile}>
                {!isMobile && <div>Nomas objekts</div>}
                <CloseButton onClose={() => setIdentifiedFeature(null)}></CloseButton>
            </PopupHeader>
            <PopupBody isMobile={isMobile}>
                <IdentifyContent></IdentifyContent>
            </PopupBody>
            <PopupFooter isMobile={isMobile}>
                <PopupButton
                    title={"Atvērt sludinājumu"}
                    icon={"icon-zemesnoma-menu-reports"}
                    onClick={() => setPreviewFeature(identifiedFeature)}
                ></PopupButton>
                {!isMobile && (
                    <PopupButton
                        title={"Attālināt"}
                        icon={"icon-zemesnoma-zoom-out"}
                        onClick={() => setZoomToSourceFeatures(1)}
                    ></PopupButton>
                )}
                {isMobile ? (
                    <PopupButton title={"Pietuvināt"} icon={"icon-zemesnoma-zoom-in"} onClick={onZoomTo}></PopupButton>
                ) : (
                    <PopupButton
                        title={"Pietuvināt"}
                        icon={"icon-zemesnoma-zoom-in"}
                        onClick={() => setLocateFeature(identifiedFeature)}
                    ></PopupButton>
                )}
            </PopupFooter>
        </Popup>
    );
};

const IdentifyContent = () => {
    const [images, setImages] = useState<GalleryImage[]>([]);
    const [showGallery, setShowGallery] = useState(false);

    const { activeTab, identifiedFeature } = useNomaContext();
    const identifyConfig = config.dataView.tabs.find((tabConfig) => tabConfig.tabValue === activeTab).identify;

    useEffect(() => {
        if (identifiedFeature) {
            setShowGallery(false);
            getRelatedImagesUrls(identifiedFeature.get("OBJECTID")).then(
                (urls: GalleryImage[]) => urls && urls.length && setImages(urls),
                () => {
                    console.log("Objektam nav attēlu");
                }
            );
        }
    }, [identifiedFeature]);

    useEffect(() => {
        images.length && setShowGallery(true);
    }, [images]);

    const getConditionalField = (condition: IIdentifyCondition) => {
        const value = identifiedFeature.get(condition.field);
        if (value === null || value === undefined) {
            return;
        }

        const conditionIsMet =
            condition.condition === Condition.Is
                ? value.toString() === condition.value
                : value.toString() !== condition.value;

        return conditionIsMet
            ? condition.showFields.map((field) => (
                  <PopupRow
                      fieldName={field}
                      feature={identifiedFeature}
                      key={"popup-row-conditional-" + field}
                  ></PopupRow>
              ))
            : null;
    };

    return (
        <>
            {showGallery ? <Gallery images={images}></Gallery> : null}
            {identifyConfig.fields.map((fieldName) => (
                <PopupRow
                    fieldName={fieldName}
                    feature={identifiedFeature}
                    key={"popup-row-common" + fieldName}
                ></PopupRow>
            ))}
            {identifyConfig.conditionalFields.map((condition) => getConditionalField(condition))}
        </>
    );
};
